module.exports = __webpack_public_path__ + "img/classe1.f2bf8827.jpg";